import axios from 'axios';
import axiosRetry from 'axios-retry';

// 1. 建立自訂的 Axios 實例
const request = axios.create();

// 2. 綁定 axios-retry 配置
const retiries = 3;
axiosRetry(request, {
  retries: retiries,
  retryDelay: (retry_count) => {
    return retry_count * 1000; // 每次重試間隔：1秒、2秒、3秒
  },
  retryCondition: (error) => {
    // 網路錯誤、伺服器 5xx 錯誤，或是 API 限流 (429) 時才重試
    return (
      axiosRetry.isNetworkOrIdempotentRequestError(error) || 
      (error.response && error.response.status === 429)
    );
  }
});

// 3. 設定請求攔截器，例如攜帶 Token 或統一處理錯誤提示
request.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

// 4. 設定回應攔截器
request.interceptors.response.use(
  (response) => response,
  (error) => {
    // const retry_config = (error && error.config && error.config['axios-retry'])
    //   ? error.config['axios-retry']
    //   : undefined;
    
    // 檢查是否有啟用 axios-retry，且目前的重試次數已經等於我們設定的 retries
    // if (retry_config && retry_config.retryCount === retiries) {
    //   // 範例：跳出全域的錯誤提示、導向錯誤頁面、或記錄日誌
    //   // console.error(`自動重試 ${retiries} 次後仍然失敗。開始執行最終錯誤處理...`);
    //   // alert('網路連線不穩定，請稍後再試！ The network connection is unstable, please try again later.');
    // }

    // 必須回傳 Reject，否則後面的 .catch() 會收不到錯誤
    return Promise.reject(error);
  }
)

export default request;